__webpack_require__.p = "https://react-documents-staging.staffshift.com/";